import { render, staticRenderFns } from "./PurchaseOrderReview.vue?vue&type=template&id=63a701cd"
import script from "./PurchaseOrderReview.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrderReview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports